import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useUsersService } from '../../../../apis/users/useUsersService';
import { UsersSummary } from '../users.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getParentsSummaryKey = 'get-parents-summary';

export const useParentsSummaryHook = (
  options?: UseQueryOptions<UsersSummary, TQueryError>
): UseQueryResult<UsersSummary, TQueryError> => {
  const { getParentUsersSummary } = useUsersService();

  return useQuery<UsersSummary, TQueryError>({
    queryKey: [getParentsSummaryKey],
    queryFn: () => getParentUsersSummary(),
    enabled: true,
    ...options,
  });
};
